import * as React from 'react';
import injectSheet from 'react-jss';
import { Modal, Icon } from 'antd';
import { connect } from 'react-redux';
import { tokens } from 'src/design-system';
const styles = {
  modalClass: {
    '& .ant-modal-body': {
      padding: '24px 0px 0px 0px',
      borderRadius: '5px',
    },
    '& .ant-modal-close-x': {
      marginRight: '-12px',
      marginTop: '-12px',
    },
  },
};
class CreateInquiryProtip extends React.PureComponent<any, any> {
  render() {
    const { classes, submitInquiry, inquiryData, permissions } = this.props;
    return <Modal
      closable={true}
      className={classes.modalClass}
      width={390}
      onCancel={() => submitInquiry(false)}
      visible={this.props.visible}
      footer={null}>
      <div style={{
        height: 140, display: 'flex', flexDirection: 'column', textAlign: 'center',
      }}>
        <div style={{
          paddingLeft: '24px', paddingRight: '24px', height: '50%',
          color: '#424242', fontFamily: 'Open Sans',
          fontSize: `${tokens.fontSize.body}px`, lineHeight: '19px', marginTop: '4%',
        }}>
          <Icon type="check-circle" theme="filled"
            style={{ color: '#52C41A', fontSize: `${tokens.fontSize.h1}px`,
              marginRight: '10px',
            }} />
          Inquiry {inquiryData.data.referenceNumber} has been {inquiryData.type} successfully.
        </div>
        <div style={{
          height: '50%', borderBottomRightRadius: '5px',
          backgroundColor: '#FFF5B7', borderBottomLeftRadius: '5px',
          cursor: permissions ? 'pointer' : 'default',
        }} onClick={() => permissions ? submitInquiry(true) : null}>
          <div style={{ padding: '20px 22px 0px 24px' }}>
            <Icon type="bulb" /> {permissions ? 'Send Inquiry to Freight Forwarders' :
            'Go to Inquiry List Page'}
          </div>
        </div>
      </div>
    </Modal>;
  }
}

const mapStateToProps = ({ masterData }, ownProps) => ({
  permissions: masterData.permissions.INQUIRY_SEND_ACTIONS,
});
const CreateInquiryProtipStyled = injectSheet(styles)(CreateInquiryProtip);
export default connect(mapStateToProps, null)(CreateInquiryProtipStyled);
